import { FmlxButton, FmlxCard } from 'fmlx-common-ui';
import React from 'react';
import { useHistory } from 'react-router-dom';
import LicenseHeader from './LicenseHeader';
import { useIsLicenseAutenticatorHealthy } from 'business/licenseValidator/hooks';

export default function SeatLicenseViolation() {
  const isLicenseAutenticatorHealthy = useIsLicenseAutenticatorHealthy();
  const history = useHistory();

  return (
    <div id="licenseViolation">
      <FmlxCard
        disabled={false}
        draggable={false}
        selectable={false}
        selected={false}
        type=""
        variant={FmlxCard.Variant.OUTLINED}
      >
        <FmlxCard.Body>
          <LicenseHeader />
          <div className="text-[#F7A246] text-lg">License Authenticator</div>
          <div className="border-solid border-x-0 border-t border-b border-[#E0E0E0] p-3 my-2">
            {isLicenseAutenticatorHealthy ? (
              <span>
                Seat not registered on current license. Check your license or contact
                support@formulatrix.com
                <br />
                <br />
              </span>
            ) : (
              <span>
                Unable to detect Rock Maker License Authenticator.
                <br />
                Make sure it is installed and running.
                <br />
                Contact support@formulatrix.com for assistance.
              </span>
            )}
          </div>

          <div className="flex flex-row-reverse m-2">
            <FmlxButton
              size="md"
              label="LOGOUT"
              onClick={() => {
                history.push('/logout');
              }}
            />
          </div>
        </FmlxCard.Body>
      </FmlxCard>
    </div>
  );
}
